import styled from 'styled-components';

import { Card } from 'components/ToolkitV2/CardV2/Card';

import { media } from 'helpers/breakpoints';

const SCard = styled(Card)`
  border-radius: ${({ theme }) => theme.borderRadius.default};
  box-shadow: ${({ theme }) => theme.shadow.CONTAINER};
  overflow: hidden;
  height: 100%;
  width: 200px;

  ${media.medium} {
    width: 243px;
  }
`;

const CardTitle = styled.p`
  ${({ theme }) => theme.fontSize.M16};
  color: ${({ theme }) => theme.colors.GREY_DARK};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export { SCard, CardTitle };
